module.exports = require("@material-ui/lab");